import React from 'react';
import {Box} from '@mui/material';
import type {StagedFile} from '@securspace/securspace-ui-kit';
import ImagePreviewActionToolbar from './ImagePreviewActionToolbar';
import type {ImagePreviewAction} from './ImagePreviewModal';
import {getPreviewImageSx} from './previewModalStyles';

export interface PreviewStageProps {
  file: StagedFile;
  actions: ImagePreviewAction[];
  onSelectAction: (actionId: string) => void;
  fullScreen: boolean;
}

/**
 * Plain-preview rendering for `ImagePreviewModal`: the image itself plus the
 * action toolbar underneath (hidden when `actions` is empty). Rendered only
 * when no action panel is active.
 */
const PreviewStage = ({file, actions, onSelectAction, fullScreen}: PreviewStageProps) => (
  <>
    <Box
      component="img"
      src={file.previewUrl}
      alt={file.file.name || 'Image preview'}
      sx={getPreviewImageSx(fullScreen)}
    />
    {actions.length > 0 && (
      <ImagePreviewActionToolbar actions={actions} onSelect={onSelectAction}/>
    )}
  </>
);

export default PreviewStage;

